import getMapProjection from 'helpers/map/getMapProjection'
import notifyHoneybadger from 'helpers/notifyHoneybadger'

// percentage of extra padding to include (per side)
const PADDING_PERCENT = 0.05
// minimum padding values (per side), roughly matching current aspect ratios
// note: these are set to ensure all markers will be included
const MINIMUM_PADDING = { x: 82, y: 50 }

/**
 * Computes the clip to use when taking export screenshots,
 * based on the provided bounds and current map aspect ratio
 *
 * @param {google.maps.LatLngBounds} bounds - The bounds to clip
 * @param {google.maps.Map} map - The map to use for determining projection and aspect ratio
 * @return {Object} The clip to use when capturing the screenshot
 */

export default function getScreenshotClipFromBounds(bounds, map) {
  try {
    const projection = getMapProjection(map)
    const nePixel = projection.fromLatLngToContainerPixel(bounds.getNorthEast())
    const swPixel = projection.fromLatLngToContainerPixel(bounds.getSouthWest())

    const mapDiv = map.getDiv()

    // determine exact clip for bounds
    const boundsClip = {
      x: Math.floor(swPixel.x),
      y: Math.floor(nePixel.y),
      width: Math.ceil(nePixel.x - swPixel.x),
      height: Math.ceil(swPixel.y - nePixel.y)
    }

    // extend clip to preserve aspect ratio and adad padding
    const mapAspectRatio = mapDiv.offsetWidth / mapDiv.offsetHeight

    // bounds are too wide, extend height
    if (boundsClip.width / boundsClip.height > mapAspectRatio) {
      const padding = Math.max(Math.ceil(boundsClip.width * PADDING_PERCENT), MINIMUM_PADDING.x)
      const paddedWidth = boundsClip.width + 2 * padding
      const extendedHeight = Math.ceil(paddedWidth / mapAspectRatio)

      return {
        x: boundsClip.x - padding,
        y: boundsClip.y - Math.floor((extendedHeight - boundsClip.height) / 2),
        width: paddedWidth,
        height: extendedHeight
      }
    } else {
      // bounds are too tall, extend width
      const padding = Math.max(Math.ceil(boundsClip.height * PADDING_PERCENT), MINIMUM_PADDING.y)
      const paddedHeight = boundsClip.height + 2 * padding
      const extendedWidth = Math.ceil(mapAspectRatio * paddedHeight)

      return {
        x: boundsClip.x - Math.floor((extendedWidth - boundsClip.width) / 2),
        y: boundsClip.y - padding,
        width: extendedWidth,
        height: paddedHeight
      }
    }
  } catch (err) {
    notifyHoneybadger({ err, action: { type: 'GET_SCREENSHOT_CLIP_FROM_BOUNDS', skipReport: true } })

    // a null (or undefined) clip will take a full page screenshot
    return null
  }
}



// WEBPACK FOOTER //
// ./src/helpers/map/getScreenshotClipFromBounds.js